const ActivityType = {
  COMMENTARY: "COMMENTARY",
  PROGRESS: "PROGRESS",
  UPDATE: "UPDATE"
};

export default ActivityType;
